import i18n from './index';
import { normalizeLocale } from './locale';
import { performNativeAction } from '../utils/nativeBridge';

// Fetch the rider's locale from the native bridge and apply it. Awaitable so the
// App boot can gate the first paint on it (UI paints already in the right language
// — no en->lang flash). No-op if the bridge is absent or sends nothing usable;
// the app then stays in the 'en' fallback.
export const fetchAndApplyLocale = async (): Promise<void> => {
  const res = await performNativeAction<{ language?: string } | string>(
    'data.get',
    { type: 'language' },
  );
  if (res == null) return;
  let data: any = res;
  if (typeof res === 'string') {
    try {
      data = JSON.parse(res);
    } catch {
      return; // malformed payload — keep the 'en' fallback
    }
  }
  const payload = data && data.data ? data.data : data;
  const lng = normalizeLocale(payload?.language);
  if (lng && lng !== i18n.language) {
    await i18n.changeLanguage(lng); // triggers applyDirection via languageChanged
  }
};
